<template>
	<!-- 下载中心 -->
	<div class="content1">
		<header1 :pathname="pathname" @showMobile="showMobile"></header1>

		<div class="dw">
			<div class="dw-cc">
				<div class="dw-h">资料下载</div>
				<div class="dw-s">请选择产品分类及产品查询文件</div>
				<div class="dw-select">
					<div class="item">
						<el-select @change="changeSelect1" class="custom-select" v-model="value1" placeholder="请选择">
							<el-option v-if="options1.length > 0" v-for="item in options1" :key="item.dictValue" :label="item.dictLabel"
								:value="item.dictValue">
							</el-option>
						</el-select>
					</div> 
					<div class="item">
						<el-select @change="changeSelect2" v-model="value2" placeholder="请选择">
							<el-option v-for="item in options2" :key="item.dictValue" :label="item.dictLabel"
								:value="item.dictValue">
							</el-option>
						</el-select>
					</div>
					<div class="item">
						<el-select @change="changeSelect3" v-model="value3" placeholder="请选择">
							<el-option v-for="item in options3" :key="item.dictValue" :label="item.dictLabel"
								:value="item.dictValue">
							</el-option>
						</el-select>
					</div>
					<div class="item">
						<el-input size="medium" @blur="sendInput" v-model="input" placeholder="请输入内容"></el-input>
					</div>

				</div>

				<div class="dw-list">

					<div class="item" v-for="(item, index) in list" :key="index">
						<div class="item-l">
							<img src="../../public/imgs/3841735279577_.pic.jpg" alt="">
							{{item.resourceName}}
						</div>
						<div class="item-r" @click="downUrl(item)">
							<img src="../../public/imgs/3851735279691_.pic.jpg" alt="">
							立即下载
						</div>
					</div>
					<div class="pagebox">
						<el-pagination background layout="prev, pager, next" :total="total">
						</el-pagination>
					</div>



				</div>

			</div>


		</div>




		<footer1></footer1>
		<mobilemenu v-if="isShowMobile" @hiddenMobile="hiddenMobile"></mobilemenu>
	</div>
</template>

<script>
	import {
		resourcelist,
		dataproduct_type,
		datafile_type,
		dataproduct_articleno
	} from '@/api/home.js';
	import mobilemenu from "@/components/mobile-menu.vue";
	import header1 from "@/components/header.vue";
	import footer1 from "@/components/footer.vue";
	// import {pageination} from 'vue_pageination';
	export default {
		components: {
			header1,
			footer1,
			mobilemenu
		},
		data() {
			return {
				isShowMobile: false,
				pathname: "download",
				options: [{
					value: '选项1',
					label: '选项1'
				}],
				options1: [],
				options2: [],
				options3: [],
				value: '',
				value1: '',
				value2: '',
				value3: '',
				
				valueid1: '',
				valueid2: '',
				valueid3: '',
				total: 0,
				list: [],
				pageNum: 1,

			}
		},
		created() {
			this.getresourcelist()
			this.getdataproduct_type()
			this.getdatafile_type()
			this.getdataproduct_articleno()

		},
		methods: {
			getdataproduct_type(){
				dataproduct_type({
					pageNum: this.pageNum,
					pageSize: 10
				}).then(res => {
					if (res.data.code == 200) {
						this.options1 = res.data.data
						console.log("9999", res.data)
					}
				})
			},
			getdatafile_type(){
				datafile_type({
					pageNum: this.pageNum,
					pageSize: 10
				}).then(res => {
					if (res.data.code == 200) {
						this.options3 = res.data.data
						console.log("9999", res.data)
					}
				})
			},
			getdataproduct_articleno(){
				dataproduct_articleno({
					pageNum: this.pageNum,
					pageSize: 10
				}).then(res => {
					if (res.data.code == 200) {
						this.options2 = res.data.data
						console.log("9999", res.data)
					}
				})
			},
			sendInput(e) {
				console.log(e, "22323")
			},
			changeSelect1(e) {
				this.valueid1 = e
				this.getresourcelist()
			},
			changeSelect2(e) {
				this.valueid2 = e
				this.getresourcelist()
			},
			changeSelect3(e) {
				this.valueid3 = e
				this.getresourcelist()
			},
			getresourcelist() {
				resourcelist({
					pageNum: this.pageNum,
					pageSize: 10,
					product_articleno:this.valueid2,
					file_type:this.valueid3,
					product_type:this.valueid1
				}).then(res => {
					if (res.data.code == 200) {
						this.list = res.data.rows
						this.total = res.data.total
					}
				})
			},
			downUrl(item) {
				let url = item.profile
				const a = document.createElement('a')
				a.href = url
				a.download = item.resourceName // 下载后文件名
				a.style.display = 'none'
				document.body.appendChild(a)
				a.click() // 点击下载
				document.body.removeChild(a)
			},
			showMobile() {
				console.log("ooooo")
				this.isShowMobile = true
			},
			hiddenMobile() {
				this.isShowMobile = false
			}


		}
	}
</script>

<style lang="scss">
	.content1 {

		.dw {
			width: 100%;
			background-image: linear-gradient(180deg, #008d8e26 0%, #ffffff26 21%);
			display: flex;
			justify-content: center;

			.dw-cc {

				.dw-h {
					font-weight: 500;
					color: #332C2B;
				}

				.dw-s {

					color: #332C2B;
				}

				.dw-select {
					display: flex;
					justify-content: space-between;
					align-items: center;

					.item {}
				}

				.dw-list {

					.item {

						background-color: white;
						display: flex;
						justify-content: space-between;
						align-items: center;
						box-sizing: border-box;
						border: 1px solid #EAEAEA;

						.item-l {
							justify-content: flex-start;
							align-items: center;
							color: #332C2B;

							img {}
						}

						.item-r {
							justify-content: flex-end;
							align-items: center;
							color: #22A3D3;
							cursor: pointer;

							img {}
						}
					}
				}

				.pagebox {
					justify-content: center;

				}


			}
		}
	}

	.el-pagination.is-background .btn-next.is-active,
	.el-pagination.is-background .btn-prev.is-active,
	.el-pagination.is-background .el-pager li.is-active {
		background-color: #22A3D3;
		color: white;
	}

	@media screen and (min-width: 1200px) {
		.content1 {
			padding-top: 100px;

			.dw {
				width: 100%;
				display: flex;

				.dw-cc {
					width: 1200px;
					padding: 68px 0;

					.dw-h {
						font-size: 28px;
					}

					.dw-s {
						margin-top: 8px;
						font-size: 18px;
					}

					.dw-select {
						width: 100%;
						display: flex;
						margin-top: 40px;

						.item {
							width: calc(25% - 10px);
							height: 49px;
						}
					}

					.dw-list {
						margin-top: 40px;

						.item {
							width: 100%;
							height: 65px;
							display: flex;
							padding: 0 50px;
							border: 1px solid #EAEAEA;
							margin-bottom: 24px;

							.item-l {
								display: flex;
								font-size: 18px;

								img {
									width: 20px;
									height: 20px;
									margin-right: 10px;
								}
							}

							.item-r {
								display: flex;
								font-size: 18px;

								img {
									width: 20px;
									height: 20px;
									margin-right: 10px;
								}
							}
						}
					}

					.pagebox {
						display: flex;

					}
				}
			}
		}

	}

	@media screen and (max-width: 1200px) {
		.content1 {
			padding-top: 80px;

			.dw {
				width: 100%;
				display: flex;

				.dw-cc {
					width: 100%;
					padding: 40px 20px;

					.dw-h {
						font-size: 20px;
					}

					.dw-s {
						margin-top: 6px;
						font-size: 16px;
					}

					.dw-select {
						width: 100%;
						display: flex;
						margin-top: 30px;

						.item {
							width: calc(25% - 10px);
							height: 40px;
						}
					}

					.dw-list {
						margin-top: 30px;

						.item {
							width: 100%;
							height: 50px;
							display: flex;
							padding: 0 30px;
							border: 1px solid #EAEAEA;
							margin-bottom: 15px;

							.item-l {
								display: flex;
								font-size: 15px;

								img {
									width: 16px;
									height: 16px;
									margin-right: 6px;
								}
							}

							.item-r {
								display: flex;
								font-size: 15px;

								img {
									width: 16px;
									height: 16px;
									margin-right: 6px;
								}
							}
						}
					}

					.pagebox {
						display: flex;

					}
				}
			}
		}

	}

	@media screen and (max-width: 880px) {
		.content1 {
			padding-top: 50px;

			.dw {
				width: 100%;
				display: flex;
				
				min-height:calc(100vh - 240px);
				
				.dw-cc {
					width: 100%;
					padding: 30px 10px;

					.dw-h {
						font-size: 16px;
					}

					.dw-s {
						margin-top: 6px;
						font-size: 14px;
					}

					.dw-select {
						width: 100%;
						display: flex;
						margin-top: 20px;

						.item {
							width: calc(25% - 5px);
							height: 35px;
						}
					}

					.dw-list {
						margin-top: 12px;

						.item {
							width: 100%;
							height: 50px;
							display: flex;
							padding: 0 20px;
							border: 1px solid #EAEAEA;
							margin-bottom: 12px;

							.item-l {
								display: flex;
								font-size: 14px;

								img {
									width: 16px;
									height: 16px;
									margin-right: 6px;
								}
							}

							.item-r {
								display: flex;
								font-size: 14px;

								img {
									width: 16px;
									height: 16px;
									margin-right: 6px;
								}
							}
						}
					}

					.pagebox {
						display: flex;

					}
				}
			}
		}

	}
</style>
<style scoped>
	::v-deep .el-select .el-input__inner {
		height: 100px;
	}

	::v-deep .el-select .el-input__prefix,
	::v-deep .el-select .el-input__suffix {
		height: 100px;
		line-height: 100px;
		/* 如果需要垂直居中，可以设置line-height与height相同 */
	}
</style>
